import classNames from 'classnames'
import { useMemo, useState } from 'react'

import { RichTextEditor } from 'core-components/library/richTextEditor'

import { IValidateRichTextEditorProps } from './models/IValidateRichTextEditorProps'
import { ValidationStatus } from './models/IValidationStatus'
import { Validator } from './Validator'

import styles from './ValidateRichTextEditor.module.scss'

export const ValidateRichTextEditor = (props: IValidateRichTextEditorProps) => {
  const [validateStatus, setValidateStatus] = useState<ValidationStatus>(ValidationStatus.Valid)
  const valueDependencies = useMemo(() => {
    if (props.valueDependencies) {
      return props.valueDependencies
    }
    return [props.disabled]
  }, [props.disabled, props.valueDependencies])

  return (
    <Validator
      classes={props.classes?.validatorClasses}
      value={props.value}
      throttle={props.throttle}
      checkFn={props.disabled ? null : props.checkFn}
      valueDependencies={valueDependencies}
      tooltipVisible={props.tooltipVisible}
      onChangeValidation={(status) => setValidateStatus(status)}
    >
      <RichTextEditor
        {...props}
        classes={{
          ...props.classes?.controlClasses,
          root: classNames(
            {
              [styles.richTextEditor__invalid]: validateStatus === ValidationStatus.Invalid,
            },
            props.classes?.controlClasses?.root
          ),
        }}
        borderColor={validateStatus === ValidationStatus.Invalid ? 'danger' : 'default'}
      />
    </Validator>
  )
}
